var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"placement":"left","id":"sidebar-wrap","closable":false,"visible":_vm.drawerVisible,"z-index":98,"width":_vm.width,"body-style":_vm.wrapStyle},on:{"close":_vm.handleClose}},[_c('products-list',{attrs:{"active-menu":_vm.activeMenu,"popover-align":{ offset: [5, 5] }},on:{"route-change":_vm.handleClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }